import { createContext, useContext } from 'react';
import { MapTypePolicy } from 'features/mapping/mapTypePolicy';
import { MapLayer } from 'features/mapping/mapping.constants';

export type MapContextValue = {
  policy: MapTypePolicy;
  // policyKey lets a layer be gated by a different MapLayer than its own id
  // (e.g. external/team layers route through MapLayers.TEAM_LAYER for mapType policy check).
  isLayerVisible: (
    layer: MapLayer,
    options?: { policyKey?: MapLayer },
  ) => boolean;
};

const MapContext = createContext<MapContextValue | undefined>(undefined);

export const MapContextProvider = MapContext.Provider;

export const useMapContext = (): MapContextValue => {
  const context = useContext(MapContext);
  if (!context) {
    throw new Error('useMapContext must be used within a <Map> component');
  }
  return context;
};
